export default (val, length) => {
  if (!val || !length || length < 1) {
    return [];
  }

  const pattern = new RegExp(`(?:[\uD800-\uDBFF][\uDC00-\uDFFF]|[^\uD800-\uDFFF]){1,${length}}`, 'g');

  return val.match(pattern) || [];
};
